export default function InventorySeparated() {
  return <div className="h-[1rem] w-[1px] bg-white/10" />;
}
